import { render, staticRenderFns } from "./EnacAtplDashboardLearners.vue?vue&type=template&id=ed0733e2"
import script from "./EnacAtplDashboardLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports